import { useState } from "react";
import TextField from "@mui/material/TextField";
import { HashLoader } from "react-spinners";

import { COLORS } from "../../utils/colors";
import { MainButton } from "../../components/MainButton";
import { updateEvent } from "../../api/events";

const fields1 = [
  {
    name: "location_name",
    label: "Venue Name",
  },
  {
    name: "location_city",
    label: "City",
  },
  {
    name: "location_country",
    label: "Country",
  },
];

const fields2 = [
  {
    name: "location_street",
    label: "Street",
  },
  {
    name: "location_zip",
    label: "ZIP Code",
  },
];

export const Venue = ({ event, handleSnackbar, setEvent }) => {
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    location_name: event.location_name || "",
    location_city: event.location_city || "",
    location_country: event.location_country || "",
    location_street: event.location_street || "",
    location_zip: event.location_zip || "",
  });

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleReset = () => {
    setValues({
      location_name: event.location_name,
      location_city: event.location_city,
      location_country: event.location_country,
      location_street: event.location_street,
      location_zip: event.location_zip,
    });
  };

  const handleSubmit = async () => {
    try {
      const { data, error } = await updateEvent(values, event);

      if (error) {
        handleSnackbar(error.message, "error");
        setLoading(false);
        return;
      }

      if (data) {
        setEvent(data);
        handleSnackbar("Event updated successfully", "success");
      }

      setLoading(false);
    } catch (err) {
      handleSnackbar(
        "Unknown error. Please check all fields & contact us if it persists.",
        "error"
      );
      setLoading(false);
    }
  };

  return (
    <>
      <div style={{ height: "20px" }} />
      <div
        className="standard-container"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div>
          <div
            className="container-row"
            style={{ alignItems: "center", justifyContent: "space-between" }}
          >
            <div>
              <h2>Update venue information</h2>
              <p id="subTitle">Keep the venue information up to date</p>
            </div>
          </div>
          <div style={{ height: "40px" }} />
          <div className="two-columns-fields-container">
            <div style={{ width: "-webkit-fill-available" }}>
              {fields1.map((field, index) => (
                <div className="field-container" key={index}>
                  <p
                    id="subheader"
                    style={{
                      margin: "0px 0px 3px",
                      alignSelf: "center",
                    }}
                  >
                    {field.label}
                  </p>
                  <TextField
                    fullWidth
                    disabled={loading}
                    size="small"
                    name={field.name}
                    placeholder="not set"
                    value={values[field.name]}
                    onChange={handleChange}
                    sx={{
                      "& label": {
                        paddingLeft: (theme) => theme.spacing(1),
                      },
                      "& fieldset": {
                        borderRadius: "6px",
                        border: `2px solid #f0f1f5`,
                        transition: ".2s ease-in-out all",
                      },
                      "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                        {
                          borderColor: "#f0f1f5",
                        },
                      "& .MuiOutlinedInput-input:hover": {
                        cursor: loading && "not-allowed",
                      },
                    }}
                  />
                </div>
              ))}
            </div>
            <div style={{ width: "-webkit-fill-available" }}>
              {fields2.map((field, index) => (
                <div className="field-container" key={index}>
                  <p
                    id="subheader"
                    style={{
                      margin: "0px 0px 3px",
                      alignSelf: "center",
                    }}
                  >
                    {field.label}
                  </p>
                  <TextField
                    fullWidth
                    disabled={loading}
                    size="small"
                    name={field.name}
                    placeholder="not set"
                    value={values[field.name]}
                    onChange={handleChange}
                    sx={{
                      "& label": {
                        paddingLeft: (theme) => theme.spacing(1),
                      },
                      "& fieldset": {
                        borderRadius: "6px",
                        border: `2px solid #f0f1f5`,
                        transition: ".2s ease-in-out all",
                      },
                      "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                        {
                          borderColor: "#f0f1f5",
                        },
                      "& .MuiOutlinedInput-input:hover": {
                        cursor: loading && "not-allowed",
                      },
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div
          className="container-row"
          style={{
            width: "min-content",
            alignSelf: "end",
          }}
        >
          <MainButton
            text={
              loading ? <HashLoader color={COLORS.white} size={20} /> : "Reset"
            }
            disabled={loading}
            color={COLORS.red}
            textColor={COLORS.white}
            textHoverColor={COLORS.lightRed}
            hoverColor={COLORS.red}
            shadowColor={COLORS.red}
            onClickAction={handleReset}
          />
          <MainButton
            text={
              loading ? <HashLoader color={COLORS.white} size={20} /> : "Save"
            }
            disabled={loading}
            color={COLORS.black}
            textColor={COLORS.white}
            textHoverColor={COLORS.lightGrey}
            hoverColor={COLORS.black}
            shadowColor={COLORS.mainAccent}
            onClickAction={handleSubmit}
          />
        </div>
        <div style={{ height: "20px" }} />
      </div>
    </>
  );
};
